module.exports = __webpack_public_path__ + "static/oblakoder-home-4-4a0a8b39af26ea64f5c9b82d2ea0c98f.png";